import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DataTable from 'react-data-table-component'
import { create, differenceBy, isEmpty } from 'lodash';
import { Button, MenuItem, Select } from '@mui/material';
import { toggleNoti, toggleError } from 'config/slice/message'
import NoDataComponent from './NoDataComponent';
import SearchComponent from './SearchComponent';
import TableModals from './TableModals';
import { downloadCSV } from 'utils/exportCSV';
import { useDelUserMutation, useGetUserListMutation, useUpdateUserMutation } from 'config/api/waV1_user';
import { useTranslation } from 'react-i18next';
import { KEY_COL_LABEL_USER_EMAIL, KEY_COL_LABEL_USER_NAME, KEY_COL_LABEL_USER_PHONE, KEY_COL_LABEL_USER_TITLE, KEY_ERROR_DELETE_FAILED, KEY_ERROR_FORM_EDIT_FAILED, KEY_LABEL_DELETE, KEY_LABEL_EXPORT_AS, KEY_LABEL_EXPORT_AS_CSV, KEY_LABEL_EXPORT_AS_PDF, KEY_LABEL_EXPORT_FILE_FORMAT, KEY_LABEL_FORM_CANCEL, KEY_LABEL_FORM_CONFIRM, KEY_LABEL_FORM_EDIT, KEY_LABEL_FORM_PIG_MESSAGE, KEY_LABEL_FORM_PIG_PLURAL, KEY_LABEL_FORM_PIG_ROWS_PER_PAGE, KEY_LABEL_FORM_PIG_SELECT_ALL, KEY_LABEL_FORM_PIG_SINGULAR, KEY_LABEL_FORM_TABLE_TITLE, KEY_NOTI_DELETE_SUCC, KEY_NOTI_FORM_EDIT_SUCC, KEY_NOTI_MSG_DELETE, MODULE_PREVIEW_ROUTER_FORM } from 'config/const/locale';



// table data
const tableData = [
    {
        "id": 1,
        "name": "Winifred Webb",
        "phone": "(312) 567-1323",
        "email": "auctor.velit@google.ca",
        "package": "Lambayeque",
        "numberrange": "5",
        "currency": "$51.61",
    },
    {
        "id": 2,
        "name": "Grace Mcintyre",
        "phone": "(290) 495-3645",
        "email": "amet.risus.donec@hotmail.edu",
        "package": "Los Ríos",
        "numberrange": "0",
        "currency": "$41.48",
    },
    {
        "id": 3,
        "name": "Kamal Nielsen",
        "phone": "(988) 476-4215",
        "email": "cras.pellentesque.sed@outlook.org",
        "package": "Dalarnas län",
        "numberrange": "8",
        "currency": "$20.15",
    },
    {
        "id": 4,
        "name": "Dai England",
        "phone": "1-349-337-6565",
        "email": "egestas.urna@yahoo.net",
        "package": "Nunavut",
        "numberrange": "7",
        "currency": "$17.25",
    },
    {
        "id": 5,
        "name": "Alfonso Torres",
        "phone": "1-615-327-5182",
        "email": "non@hotmail.ca",
        "package": "Assam",
        "numberrange": "1",
        "currency": "$34.18",
    }
]

/**
 * react-data-table-component for ref: https://www.npmjs.com/package/react-data-table-component/v/6.11.8#header-context-menu-when-using-selectable-rows
 * export pdf for ref: jspdf(http://raw.githack.com/MrRio/jsPDF/master/docs/index.html) and jspdf-autotable(https://github.com/simonbengtsson/jsPDF-AutoTable)
 * @Todo i18n
 */
export default function CMSTableWithUser() {

    const { t } = useTranslation(MODULE_PREVIEW_ROUTER_FORM)
    const { lng } = useSelector(state => state.global)

    // columns definition
    const columns = [
        {
            id: 'id',
            name: '#',
            selector: row => row.id,
            sortable: true,
            width: '64px',
        },
        {
            id: 'name',
            name: t(KEY_COL_LABEL_USER_NAME),
            selector: row => row.name,
        },
        {
            id: 'phone',
            name: t(KEY_COL_LABEL_USER_PHONE),
            selector: row => row.phone,
        },
        {
            id: 'email',
            name: t(KEY_COL_LABEL_USER_EMAIL),
            selector: row => row.email,
            grow: 2
        },
        {
            id: 'title',
            name: t(KEY_COL_LABEL_USER_TITLE),
            selector: row => row.title,
        }
    ];

    const [selectedRows, setSelectedRows] = useState([]); // save the selected row
    const [toggleCleared, setToggleCleared] = useState(false); // indicate whether hiding the context or not
    const [isEditTableData, setIsEditTableData] = useState(false) // indicate the row table's state: editable or uneditable
    const [allRowData, setAllRowData] = useState(tableData); // save the all table data
    let rowData = {} // save the data waiting to change

    const [expandedRows, setExpandedRows] = useState({})
    const [editRowById, setEditRowById] = useState(0)

    const [filterText, setFilterText] = useState(''); // keyword to search
    const [filterType, setFilterType] = useState(columns[0]?.id) // type to search with keyword
    // const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const [getUserListFn] = useGetUserListMutation()
    const [updateUserFn] = useUpdateUserMutation()
    const [delUserFn] = useDelUserMutation()
    const dispatch = useDispatch()


    function createRow(id, name, phone, email, title) {
        return { id, name, phone, email, title }
    }

    // filter results when conditions meet
    let filteredItems = allRowData.filter(
        item => item[filterType] && String(item[filterType]).toLowerCase().includes(filterText.toLowerCase())
    );

    // save row table's input value
    const iptOnChangeHandler =
        (id, iptType) => (event) => {
            rowData = {
                id,
                type: iptType,
                value: event.target.value
            }
        }

    // Table's subHeader
    const subHeaderComponentMemo = useMemo(() => (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: "100%" }}>
            <div style={{ display: 'flex' }}>
                {/* <Button type="button">create</Button> */}
                <TableModals columns={columns} dataSetter={setAllRowData} />

                <div style={{ paddingLeft: 16, marginLeft: 16, borderLeft: '1px solid black' }}>
                    <Select
                        variant='filled'
                        value={1}
                        disableUnderline
                        sx={{
                            '&>div': {
                                p: 1.5
                            }
                        }}
                    >
                        <MenuItem value={1} disabled hidden >{t(KEY_LABEL_EXPORT_AS)}</MenuItem>
                        <MenuItem onClick={() => downloadCSV(isEmpty(selectedRows) ? allRowData : selectedRows)}>{t(KEY_LABEL_EXPORT_AS_CSV)}</MenuItem>
                        <MenuItem onClick={() => exportPdf(selectedRows, allRowData)}>{t(KEY_LABEL_EXPORT_AS_PDF)}</MenuItem>
                        {/* <MenuItem>SQL</MenuItem> */}
                        {/* <MenuItem>JSON</MenuItem> */}
                        {/* <MenuItem>XML</MenuItem> */}
                        {/* <MenuItem>MS-Excel</MenuItem> */}
                    </Select>
                </div>
            </div >
            {/* <input placeholder='type keyword to search' onChange={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} /> */}
            < SearchComponent columns={columns} Kword={filterText} saveKeyword={setFilterText} KType={filterType} ChangeKType={setFilterType} />
        </div >
    ), [
        filterText,
        filterType,
        selectedRows,
        allRowData,
        lng
        // resetPaginationToggle
    ]);

    //save the selected rows data to state
    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    useEffect(() => {
        getUserListFn()
            .then(
                res => {
                    setAllRowData(
                        new Array(...(res?.data?.data?.users?.data))
                            .map(
                                i => createRow(
                                    i.id,
                                    i.name,
                                    i.phone,
                                    i.email,
                                    new Array(...i.roles).map(ii => ii + ' ')
                                )
                            )
                    )
                }
            )
            .catch(
                reason => console.log(reason)
            )

    }, [])

    // context component includes delete action
    const contextActions = useMemo(() => {
        const handleDelete = () => {

            if (window.confirm(t(KEY_NOTI_MSG_DELETE))) {
                selectedRows.map(
                    i => delUserFn(i.id)
                        .then(res => {
                            if (res.data?.data) {
                                dispatch(toggleNoti({
                                    indicator: true,
                                    msg: t(KEY_NOTI_DELETE_SUCC)
                                }))
                                window.location.reload()
                            } else {
                                dispatch(toggleError({
                                    indicator: true,
                                    msg: t(KEY_ERROR_DELETE_FAILED)
                                }))
                            }
                        })
                        .catch(reason => {
                            dispatch(toggleError({
                                indicator: true,
                                msg: t(KEY_ERROR_DELETE_FAILED)
                            }))
                        })
                        .finally(() => {
                            setToggleCleared(!toggleCleared);
                        })
                )
                // setAllRowData(differenceBy(allRowData, selectedRows, 'id'));
            }
        };

        return (
            <Button
                key="delete"
                variant="danger"
                onClick={handleDelete}
                style={{ backgroundColor: 'red', color: 'white', fontSize: 14, fontWeight: 700 }} >
                {t(KEY_LABEL_DELETE)}
            </Button >
        );
    }, [allRowData, selectedRows, toggleCleared]);

    // save changed row data to state
    const confirmChange = useCallback(() => {
        updateUserFn(rowData)
            .then(
                res => {
                    if (res.data?.data) {
                        dispatch(toggleNoti({
                            indicator: true,
                            msg: t(KEY_NOTI_FORM_EDIT_SUCC)
                        }))
                        window.location.reload()
                    } else {
                        dispatch(toggleError({
                            indicator: true,
                            msg: t(KEY_ERROR_FORM_EDIT_FAILED)
                        }))
                    }
                }
            )
            .catch(
                reason => dispatch(toggleError({
                    indicator: true,
                    msg: t(KEY_ERROR_FORM_EDIT_FAILED)
                }))
            )
            .finally(() => {
                setIsEditTableData(false)
            })
        // if (isEmpty(rowData) && isEmpty(rowData?.id)) return setIsEditTableData(false)
        // // setAllRowData(pre => pre.map(i => (i.id === rowData.id) ? set(i, rowData.type, rowData.value) : i))
        // setAllRowData(pre => pre.map(i => (i.id === rowData.id) ? { ...i, [rowData?.type]: rowData?.value } : i))
        // setIsEditTableData(false)
    }, [rowData, allRowData])

    /**
     * expanded component ?? bad performance ??
     * @param {Object} data the expanded row data
     */
    const ExpandedComponent = ({ data }) => {

        const arr = []

        const edit = editRowById === expandedRows?.id

        const fn1 = () => {

            for (let datum in data) {
                if (datum === 'id') continue
                arr.push(
                    <tr key={datum} style={{ lineHeight: 2 }} >
                        <td><label htmlFor={datum}>{datum}</label></td>
                        <td>
                            {
                                (isEditTableData && edit) ? (
                                    <input
                                        id={datum}
                                        name={datum}
                                        type="text"
                                        className='ms-5'
                                        defaultValue={data[datum]}
                                        onChange={iptOnChangeHandler(data['id'], datum)}
                                    />
                                ) : (
                                    <div className='ms-5'>{data[datum]}</div>
                                )
                            }

                        </td>
                    </tr>
                )
            }
        }

        const editRowTableHandler = () => { setIsEditTableData(!isEditTableData); setEditRowById(data?.id) }

        fn1()

        return (
            <table style={{ margin: "20px auto" }}>
                <tbody>
                    {arr}
                </tbody>
                <tfoot>
                    <tr>
                        <td style={{ paddingTop: 8 }}>
                            <Button
                                variant='info'
                                style={{ backgroundColor: 'lightgray' }}
                                onClick={editRowTableHandler}
                            >
                                {(isEditTableData && edit) ? t(KEY_LABEL_FORM_CANCEL) : t(KEY_LABEL_FORM_EDIT)}
                            </Button>
                        </td>
                        <td>
                            {
                                (isEditTableData && edit) &&
                                <Button
                                    variant='info'
                                    className='ms-5'
                                    style={{ backgroundColor: 'lightgray' }}
                                    onClick={confirmChange}
                                >
                                    {t(KEY_LABEL_FORM_CONFIRM)}
                                </Button>
                            }
                        </td>
                    </tr>
                </tfoot>
            </table>
        )
    }

    // const actionsMemo = useMemo(() => <Export onExport={() => downloadCSV(data)} />, []);


    const handleChange = ({ allSelected, selectedCount, selectedRows }) => {
        // You can set state or dispatch with something like Redux so we can use the retrieved data
        console.log('Selected Rows: ', selectedRows);
    };

    // export pdf func waiting to optimize
    const exportPdf = useCallback(() => {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);

                const exportColumns = columns.map((col) => ({ title: col.name, dataKey: col.id }));

                doc.autoTable(exportColumns, isEmpty(selectedRows) ? allRowData : selectedRows);
                doc.save(t(KEY_LABEL_EXPORT_FILE_FORMAT));
            });
        });
    }, [columns, selectedRows, allRowData])


    return (
        <DataTable
            title={t(KEY_LABEL_FORM_TABLE_TITLE)}

            subHeader
            subHeaderComponent={subHeaderComponentMemo}

            columns={columns}
            data={filteredItems}

            // selected row
            selectableRows
            selectableRowsHighlight
            selectableRowsVisibleOnly
            onSelectedRowsChange={handleRowSelected}
            clearSelectedRows={toggleCleared}

            // expanded row
            expandableRows
            expandableRowsComponent={ExpandedComponent}
            expandOnRowDoubleClicked
            expandableRowExpanded={(row) => expandedRows?.id === row.id ? true : false}
            onRowExpandToggled={(toggleState, row) => {
                // console.log(toggleState, row)
                if (toggleState) setExpandedRows(row)
            }}

            // sorting setting
            defaultSortFieldId={'id'}
            defaultSortAsc

            // context setting
            // contextComponent={<div>hello</div>}
            contextActions={contextActions}
            contextMessage={{
                singular: t(KEY_LABEL_FORM_PIG_SINGULAR),
                plural: t(KEY_LABEL_FORM_PIG_PLURAL),
                message: t(KEY_LABEL_FORM_PIG_MESSAGE)
            }}

            pagination
            paginationRowsPerPageOptions={[10, 20, 50, 100]}
            paginationComponentOptions={{
                rowsPerPageText: t(KEY_LABEL_FORM_PIG_ROWS_PER_PAGE),
                rangeSeparatorText: '/',
                noRowsPerPage: false,
                selectAllRowsItem: true,
                selectAllRowsItemText: t(KEY_LABEL_FORM_PIG_SELECT_ALL)
            }}

            noDataComponent={<NoDataComponent />}

            highlightOnHover
            striped
            responsive


        />
    )
}
